import { type PlacementId } from '@schibsted-nmp/advertising-shared';

import { debug as _debug } from './.debug.js';

const debug = _debug.withSublabel('Event', 'slotVisibilityChanged');

/** Fired when the on-screen percentage of the ad slot changes. */
export function onSlotVisibilityChanged(
  event: googletag.events.SlotVisibilityChangedEvent
) {
  const placementId = event.slot.getSlotElementId() as PlacementId;

  debug.withPlacementLabel(placementId)
    .message`${event.inViewPercentage}%`().verbose();
}
